import {GUID} from "../../shared/models/GUID-interface";
import {ChartLineModel} from "./amchart/chart-line-model";
import {b} from "@angular/core/src/render3";
import {BGChartType} from "./b-g-chart-type";
import {ChartAggModel} from "./amchart/chart-aggregation";
import {ChartData} from "./chart-data";

export class UpdateStaticPopupGUID implements GUID{
    constructor(public readonly GUID: string, public isMainChart, public dateAxis?: any){
    }
}

export class UpdateInfoParamGUID implements GUID{
    constructor(public readonly GUID: string, public param: string, public val: any){
    }
}

export class GenerateLinesGUID implements GUID{
    constructor(public readonly GUID: string, public chartLines: ChartLineModel[], public bubbleChartLines: ChartLineModel[]){
    }
}

export class HoverLineGUID implements GUID{
    constructor(public readonly GUID: string, public lineName: string, public chart: 'bubble' | 'line', public hover: boolean){
    }
}

export class LoadingSummaryLineDataGUID implements GUID{
    constructor(public readonly GUID: string, public line: ChartLineModel, public loadStart: boolean, public loadEnd: boolean){
    }
}

export class UpdateChartAggGUID implements GUID{
    constructor(public readonly GUID: string, public agg: ChartAggModel[], public isMainChart: boolean, public period: string){
    }
}

export class RangeAggGUID implements GUID{
    constructor(public readonly GUID: string, public range: any){
    }
    public isMainChart: boolean;
}

export class ChartDimensionsGUID implements GUID{
    constructor(public readonly GUID: string, public update: boolean){
    }
}

export class UpdateChartGUID implements GUID{
    constructor(
        public readonly GUID: string,
        public chart: any,
        public dateAxis: any,
        public chartData: ChartData,
        public bubbleChart: any,
        public bubbleDateAxis: any,
        public bubbleChartData: any[],
        public isMainChart: boolean
    ){
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/update-static-popup-GUID.ts